import { render, staticRenderFns } from "./NextDoubleIcon.vue?vue&type=template&id=4499d496&scoped=true&"
import script from "./NextDoubleIcon.vue?vue&type=script&lang=js&"
export * from "./NextDoubleIcon.vue?vue&type=script&lang=js&"
import style0 from "./NextDoubleIcon.vue?vue&type=style&index=0&id=4499d496&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4499d496",
  null
  
)

export default component.exports